import sendApiRequest from '../helpers/axios-setup';
import { stringify as QStringify } from 'qs';

export async function getWeeklyActionRecordTemplateList(
  page,
  limit,
) {
  try {
    const response = await sendApiRequest.get('/weekly-action-record-template', {
      params: {
        page: page,
        limit: limit,
      }
    });
    return response.data?.data[0];
  } catch (e) {
    return null;
  }
}


export async function addNewWeeklyActionRecordTemplate(data) {
    const responseMap = {
    response: null,
    error: null
  };

  try {
    const response =  await sendApiRequest.post('/weekly-action-record-template', data);
    responseMap.response = response.data;
  } catch (error) {
    responseMap.error = error?.response?.data?.error;
  }
  return responseMap;
};


export async function updateWeeklyActionRecordTemplate(data, reportId) {
    const responseMap = {
    response: null,
    error: null
  };
  try {
    const response =  await sendApiRequest.put(`/weekly-action-record-template/${reportId}`, data);
    responseMap.response = response.data;
  } catch (error) {
    responseMap.error = error?.response?.data?.error;
  }
  return responseMap;
};

export async function deleteWeeklyActionRecordTemplate(reportId) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response =  await sendApiRequest.delete(`/weekly-action-record-template/${reportId}`);
    responseMap.response = response.data;
  } catch (error) {
    responseMap.error = error?.response?.data?.error;
  }
  return responseMap;
};


export async function getWeeklyActionRecordTemplateDetails(reportId) {
  try {
    const response =  await sendApiRequest.get(`/weekly-action-record-template/${reportId}`);
    return response.data?.data;
  } catch (error) {
    return null;
  }
};

export async function getWeeklyActionRecordTemplateByOfferingId(offering_id) {
  try {
    const response =  await sendApiRequest.get(`/weekly-action-record-template/offering/${offering_id}`);
    return response.data?.data;
  } catch (error) {
    return null;
  }
};